export class FailedLoginPostConditionError extends Error {
  constructor(public readonly messageKey: string) {
    super();
    this.name = 'FailedLoginPostConditionError';
    this.message = `Failed login post condition`;
  }
}
